import { put } from 'redux-saga/effects';
import { actions as sessionActions } from './session';

export const SET_TOKEN = 'uneed/token/SET_TOKEN';

const initialState = {
  token: '',
};

export default function reducer(state = initialState, action = {}) {
  if (action.type === SET_TOKEN) {
    return {
      ...state,
      token: action.token,
    };
  }
  return state;
}

export function setToken(token, shouldStartSession) {
  return {
    type: SET_TOKEN,
    token,
    shouldStartSession,
  };
}

export function* watchSetToken(client, { token, shouldStartSession }) {
  yield (client.token = token);
  if (shouldStartSession) {
    yield put(sessionActions.load());
  }
}
